module.exports = __webpack_public_path__ + "img/mat_703.b59af447.png";